import { ReactComponent as LinkedInSvg } from '../assets/linkedin.svg';

const LinkedInIcon = () => (
  <LinkedInSvg />
);

export default LinkedInIcon;
